/**
 * F-135: a video's picture size, read by the browser from the LOCAL file
 * before it is placed — the one thing the server's header sniff cannot
 * promise for every container (WebM keeps it deep in an EBML tree the server
 * does not walk), and the browser already has a decoder for anything it will
 * later play. `preload="metadata"` reads only the headers, so this costs a
 * few hundred KB of a 30 MB clip, and a container the browser cannot open
 * (or a slow disk) resolves to null after `timeoutMs` rather than hanging
 * the drop — the element then takes the default 16:9 box.
 */
export function probeVideoSize(
  file: Blob,
  timeoutMs = 4000,
): Promise<{ w: number; h: number } | null> {
  return new Promise((resolve) => {
    const url = URL.createObjectURL(file);
    const video = document.createElement("video");
    video.preload = "metadata";
    video.muted = true;
    let settled = false;
    const finish = (result: { w: number; h: number } | null) => {
      if (settled) return;
      settled = true;
      window.clearTimeout(timer);
      video.removeAttribute("src");
      video.load();
      URL.revokeObjectURL(url);
      resolve(result);
    };
    const timer = window.setTimeout(() => finish(null), timeoutMs);
    video.onloadedmetadata = () =>
      finish(
        video.videoWidth > 0 && video.videoHeight > 0
          ? { w: video.videoWidth, h: video.videoHeight }
          : null,
      );
    video.onerror = () => finish(null);
    video.src = url;
  });
}
